import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { SalesOrderLineAuditByField as lineAuditEntity } from '../../graphql/entities';
import { default as Form } from '../connectedForm';

import { FilterOperation, IFilterInput } from '../../graphql/schema/p4types';
import { BasicHeader } from '../../actions/BasicHeader';
import FluentModal from '../modals/FluentModal';

const LazySalesOrderLineEventWorkspace = React.lazy(() => import('views/sales/SalesOrderLineEventWorkspace'));
const LazyAuditByFieldWorkspace = React.lazy(() => import('views/company/AuditByFieldWorkspace'));

const LineDetailModal = ({
  modalOpen,
  updateCellState,
  updateModalOpen,
  selectValue,
  focusOnInput,
  modalProps,
  selectedId,
}: {
  modalOpen: boolean;
  updateCellState?: Function;
  updateModalOpen: (modalOpen: boolean) => void;
  selectValue: Function;
  focusOnInput: () => void;
  modalProps: any;
  selectedId: number;
}) => {
  const [openedAtLeastOnce, setOpenedAtLeastOnce] = useState(false);

  useEffect(() => {
    if (modalOpen) {
      setOpenedAtLeastOnce(true);
    }
  }, [modalOpen]);

  const hideModal = useCallback(() => {
    if (updateCellState) {
      updateCellState({ modalOpen: false });
    }
    updateModalOpen(false);
  }, [updateCellState, updateModalOpen]);

  const onRowClick = useCallback(
    (rowData) => {
      if (rowData) {
        selectValue(rowData);
        focusOnInput();
        hideModal();
      }
    },
    [focusOnInput, hideModal, selectValue]
  );

  const idFilter = useCallback<Array<IFilterInput>>(
    (field) => [
      {
        filterOperation: FilterOperation.Equals,
        filterParameters: {
          field: field,
          value: selectedId,
        },
      },
    ],
    [selectedId]
  );

  const workspaceProps = useMemo(() => {
    let props: any = {};
    if (typeof modalProps === 'function') {
      props = Object.assign({}, modalProps(), { key: 'modal' });
    } else {
      props = Object.assign({}, modalProps, { key: 'modal' });
    }

    props.onClose = hideModal;
    props.onBack = hideModal;
    props.lookupView = true;
    props.embeddedView = true;
    props.onRowClick = onRowClick;
    props.backButtonRequired = true;
    props.noEdit = true;
    props.className = 'ignore-react-onclickoutside';

    return props;
  }, [hideModal, modalProps, onRowClick]);

  return (
    <FluentModal
      isOpen={modalOpen}
      styles={{ main: { minWidth: '500px', width: window.innerWidth - 300 }, scrollableContent: { height: '94vh' } }}
    >
      <BasicHeader>Line History/Audit</BasicHeader>
      {openedAtLeastOnce ? (
        <Form.TabPanel>
          <Form.TabContent id="history" label="History">
            <LazySalesOrderLineEventWorkspace
              embeddedView={true}
              predefinedFilters={idFilter('salesOrderLine.id')}
              viewScreenName="/sales/SalesOrderLineEvent/Workspace"
              {...workspaceProps}
            />
          </Form.TabContent>
          <Form.TabContent id="audit" label="Audit">
            <LazyAuditByFieldWorkspace
              embeddedView={true}
              predefinedFilters={idFilter('id')}
              viewScreenName="/sales/SalesOrderLineAudit/Workspace"
              entity={lineAuditEntity}
              {...workspaceProps}
            />
          </Form.TabContent>
        </Form.TabPanel>
      ) : null}
    </FluentModal>
  );
};

export default LineDetailModal;
